import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { TableTaiSan } from "./TableTaiSan";
import { useSelector, useDispatch } from "react-redux";
import {
  getListTaiSan,
  updateDataSearch,
} from "../../../../actions/DanhSachTaiSan/";
import { currentDate } from "utils/formatDate";
import DanhSachTaiSanApi from "../../../../service/danhSachTaiSanApi";
import { pushNotification } from "utils/notifications";
import { DanhSachTaiSanCombo } from "constants/danhSachTaiSanConst";
import StoreApi from "../../../../service/storeApi";
import { Controller } from "react-hook-form";
import { useForm } from "react-hook-form";
import userApi from "../../../../service/userApi";
import { convertToNumber } from "utils/numberExtension";
import DateTimePicker from "../../../../components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";

export const ModalThuHoi = (props) => {
  const currentForm = useForm();
  const { register, control } = currentForm;
  const [dataCombo, setdataCombo] = useState(DanhSachTaiSanCombo.KhoCombo);

  const dataOption = {
    nguoiTaoOption: [
      {
        label: "Test828@gmail.com",
        value: "Test828@gmail.com",
      },
      {
        label: "Test@gmail.com",
        value: "Test@gmail.com",
        selected: true,
      },
    ],
    nguoiGiaoDichOption: [
      {
        label: "Test828@gmail.com",
        value: "Test828@gmail.com",
      },
      {
        label: "Test@gmail.com",
        value: "Test@gmail.com",
      },
    ],
  };

  const [listUser, setListUser] = useState(dataOption.nguoiGiaoDichOption);

  //Khai báo phí thu mượn
  const chiTietPhiThuMuon = {
    PhiThuChoMuon: "",
    MaTaiSan: "",
    ChiTiet: "",
  };
  const [contentThongTinTaiSan, setContentThongTinTaiSan] =
    useState(chiTietPhiThuMuon);
  //Code
  const dataSearch = useSelector((state) => state.dataSearchTaiSan);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  //Khai báo trường thu hôi
  const initData = {
    TaiSanID: props.taisanId,
    NgayTao: currentDate(),
    NguoiTao: "",
    PhiThuHoi: 0,
    NguoiNop: "",
    NguoiGiaoDich: "",
    KhoNhap: "",
    LyDo: "",
  };
  const [dataThuHoi, setDataThuHoi] = useState(initData);

  const updateDropdown = (field) => (e) => {
    setDataThuHoi({
      ...dataThuHoi,
      [field]: e.target.value,
    });
    if (e.target.value === "" || e.target.value === "0") {
      setErrors({
        ...errors,
        nguoiGiaoDich: "Chọn người giao dịch",
      });
    } else {
      setErrors({
        ...errors,
        nguoiGiaoDich: "",
      });
    }
  };

  //Set Data khi Update trường dữ liệu
  const updateTextValue = (field) => (e) => {
    setDataThuHoi({
      ...dataThuHoi,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors1({
        ...errors1,
        nguoiNop: "Nhập tên người nộp",
      });
    } else {
      setErrors1({
        ...errors1,
        nguoiNop: "",
      });
    }
  };
  const onChangeNumber = (field) => (evt) => {
    setDataThuHoi({
      ...dataThuHoi,
      [field]: convertToNumber(evt.target.value),
    });
    if (evt.target.value === "") {
      setErrors2({
        ...errors2,
        phiThuHoi: "Nhập tiền",
      });
    } else {
      setErrors2({
        ...errors2,
        phiThuHoi: "",
      });
    }
  };

  const onChangeDate = (field) => (evt) => {
    setDataThuHoi({
      ...dataThuHoi,
      [field]: formatDayMonth(evt),
    });
    if (evt === "null") {
      setErrors3({
        ...errors3,
        ngayTao: "Nhập ngày tạo",
      });
      // NgayThanhToan.current.focus();
    } else {
      setErrors3({
        ...errors3,
        ngayTao: "",
      });
    }
  };

  useEffect(() => {
    //Code lấy kho
    StoreApi.combo({}).then((response) => {
      // console.log(response.data);
      const dataComboReturn = response.data.map((item) => ({
        value: item.value,
        label: item.StoreName,
      }));
      setdataCombo(dataComboReturn);
      dataThuHoi.KhoNhap = dataComboReturn[0].value;
    });
    //Code lấy list user
    userApi.combo().then((response) => {
      const dataComboUser = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setListUser(dataComboUser);
    });
    //Code lấy user hiện tại
    userApi.getCurrentUser().then((response) => {
      setDataThuHoi({
        ...dataThuHoi,
        NguoiTao: response.data.FullName,
      });
    });
    //Code lấy thông tin phí thu
    DanhSachTaiSanApi.phiThuTaiSan(props.taisanId).then((response) => {
      setContentThongTinTaiSan({
        ...contentThongTinTaiSan,
        PhiThuChoMuon: response.data.PhiThuChoMuon,
        MaTaiSan: response.data.MaTaiSan,
        ChiTiet: response.data.ChiTiet,
      });
    });
  }, []);

  //Thông báo
  const validateName = (NguoiNop) => {
    const expression = /(\w.).+/i;
    return expression.test(String(NguoiNop).toLowerCase());
  };

  const initErrors = {
    nguoiGiaoDich: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = {
    nguoiNop: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const initErrors2 = {
    phiThuHoi: "",
  };
  const [errors2, setErrors2] = useState(initErrors2);
  const initErrors3 = {
    ngayTao: "",
  };
  const [errors3, setErrors3] = useState(initErrors3);

  const onSubmit = () => {
    if (
      dataThuHoi.NguoiGiaoDich === listUser[0].value ||
      dataThuHoi.NguoiGiaoDich === ""
    ) {
      setErrors({
        ...errors,
        nguoiGiaoDich: "Chọn người giao dịch",
      });
    } else if (dataThuHoi.NguoiNop === "") {
      setErrors1({
        ...errors1,
        nguoiNop: "Nhập tên người nộp",
      });
    } else if (!validateName(dataThuHoi.NguoiNop)) {
      setErrors1({
        ...errors1,
        nguoiNop: "Họ tên phải có ít nhất 2 từ",
      });
    } else if (dataThuHoi.PhiThuHoi === "") {
      setErrors2({
        ...errors2,
        phiThuHoi: "Nhập tiền",
      });
    } else if (
      dataThuHoi.NgayTao === "null" ||
      dataThuHoi.NgayTao === null ||
      dataThuHoi.NgayTao === ""
    ) {
      setErrors3({
        ...errors3,
        ngayTao: "Nhập ngày tạo",
      });
    } else {
      DanhSachTaiSanApi.thuHoi(
        dataThuHoi.TaiSanID,
        dataThuHoi.NgayTao,
        dataThuHoi.NguoiTao,
        dataThuHoi.PhiThuHoi,
        dataThuHoi.NguoiNop,
        dataThuHoi.NguoiGiaoDich,
        dataThuHoi.KhoNhap,
        dataThuHoi.LyDo
      ).then((response) => {
        console.log(response.data, "hfasdf");
        pushNotification(
          "Thu hồi tài sản thành công.",
          "success",
          "TOP_CENTER",
          1000
        );
        props.onHide();
        dispatch(getListTaiSan(dataSearch));
      });
    }
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/logo-thuhoi-v2.png" />
          </span>{" "}
          Thu Hồi
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal form-edit">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse19634"
                className="card-header "
                href="#collapse19634"
                aria-expanded="true"
                aria-controls="collapse19634"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Thu hồi</h3>
                </a>
              </div>
              <div
                id="collapse19634"
                aria-labelledby="headingCollapse9634"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="color7-bold">Ngày tạo</label>
                              <DateTimePicker
                                value={convertDate(dataThuHoi.NgayTao)}
                                name="NgayThanhToan"
                                onChange={onChangeDate("NgayTao")}
                                // customInputRef={NgayThanhToan}
                              ></DateTimePicker>
                              {errors3.ngayTao && (
                                <span className="canh-bao-red">
                                  {errors3.ngayTao}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Phí thu cho mượn"
                              value={formatNumber(
                                contentThongTinTaiSan.PhiThuChoMuon
                              )}
                              disabled="disabled"
                            ></TextInputOnRow>
                          </div>

                          <div className="col-md-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Phí thu hồi"
                              inputProps={{
                                name: "PhiThuHoi",
                                // ref: TienThanhToan,
                                onChange: onChangeNumber("PhiThuHoi"),
                                value: formatNumber(dataThuHoi.PhiThuHoi),
                              }}
                            ></TextInputOnRow>
                            {errors2.phiThuHoi && (
                              <span className="canh-bao-red">
                                {errors2.phiThuHoi}
                              </span>
                            )}
                          </div>

                          <div className="col-md-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Người tạo"
                              value={dataThuHoi.NguoiTao}
                              disabled="disabled"
                            ></TextInputOnRow>
                          </div>

                          <div className="col-md-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Người nộp"
                              inputProps={{
                                name: "NguoiNop",
                                // ref: NguoiNhan,
                                onChange: updateTextValue("NguoiNop"),
                                value: dataThuHoi.NguoiNop,
                              }}
                            ></TextInputOnRow>
                            {errors1.nguoiNop && (
                              <span className="canh-bao-red">
                                {errors1.nguoiNop}
                              </span>
                            )}
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="color7-bold">
                                Người giao dịch
                              </label>
                              <Controller
                                control={control}
                                name="NguoiGiaoDich"
                                // rules={{ required: "Hãy chọn kho" }}
                                render={({ onChange, onBlur, value }) => (
                                  <select
                                    // onChange={updateDropdown("KhoID")}
                                    onChange={(evt) => {
                                      onChange(evt);
                                      updateDropdown("NguoiGiaoDich")(evt);
                                    }}
                                    value={dataThuHoi.NguoiGiaoDich}
                                    defaultValue={dataThuHoi.NguoiGiaoDich}
                                    className="form-control input-sm"
                                  >
                                    {listUser &&
                                      listUser.map((item, idx) => (
                                        <option value={item.value}>
                                          {item.label}
                                        </option>
                                      ))}
                                  </select>
                                )}
                              />
                              {errors.nguoiGiaoDich && (
                                <span className="canh-bao-red">
                                  {errors.nguoiGiaoDich}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="color7-bold">Kho nhập</label>
                              <Controller
                                control={control}
                                name="KhoNhap"
                                // rules={{ required: "Hãy chọn kho" }}
                                render={({ onChange, onBlur, value }) => (
                                  <select
                                    // onChange={updateDropdown("KhoID")}
                                    onChange={(evt) => {
                                      onChange(evt);
                                      updateDropdown("KhoNhap")(evt);
                                    }}
                                    value={dataThuHoi.KhoNhap}
                                    defaultValue={dataThuHoi.KhoNhap}
                                    className="form-control input-sm"
                                  >
                                    {dataCombo &&
                                      dataCombo.map((item, idx) => (
                                        <option value={item.value}>
                                          {item.label}
                                        </option>
                                      ))}
                                  </select>
                                )}
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="color7-bold">Lý do</label>
                              <textarea
                                rows="1"
                                className="form-control input-sm  text-era"
                                name="comment"
                                value={dataThuHoi.LyDo}
                                onChange={updateTextValue("LyDo")}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 mt-1">
                        <TableTaiSan
                          contentThongTinTaiSan={contentThongTinTaiSan}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer ">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
        <a
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={onSubmit}
        >
          <span>
            <img src="/app-assets/images/icon-save-v2-white.png" />
          </span>
          Xác nhận
        </a>
      </Modal.Footer>
    </Modal>
  );
};
